import type { RouteObject } from "react-router-dom";
import MemoryCenter from "@/pages/memory/MemoryCenter";
import MemoryClassDetail from "@/pages/memory/MemoryClassDetail";


// TODO(perf): lazy-load these non-first-screen pages with a shared, accessible Suspense fallback.
export const memoryRoutes: RouteObject[] = [
  {
    path: "/plugins/memories",
    element: <MemoryCenter />,
  },
  {
    path: "/plugins/memories/classes/:uid",
    element: <MemoryClassDetail />,
  },
];
